import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
    private subject = new Subject<boolean>();

    setLoading(loading: boolean) {
        this.subject.next(loading);
    }

    isLoading(): Observable<any> {
        return this.subject.asObservable();
    }
}